import { observer } from 'mobx-react';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';
import { palette } from '../../design-system/colors';

const useStyles = makeStyles(() => ({
    linkTooltip: {
        color: palette.graphite.onyx,
        fontSize: '12px',
        fontWeight: 400,
        position: 'absolute',
        textAlign: 'start',
        border: '1px solid #cccccc',
        padding: '6px',
        borderRadius: '2px',
        backgroundColor: palette.graphite.white,
        boxShadow: '0px 0px 21px -4px rgba(0, 0, 0, 0.17)',
        zIndex: 1000,
        visibility: 'hidden',
    },

    isVisible: {
        visibility: 'visible',
    },
}));

function EmailLinksTooltip({ isVisible, text }) {
    const classes = useStyles();

    return (
        <div
            className={classnames([classes.linkTooltip], {
                [classes.isVisible]: !!isVisible,
            })}
        >
            {text}
        </div>
    );
}

export default observer(EmailLinksTooltip);
